import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "bank-update-requests-container" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-header pb-0" }
const _hoisted_7 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_8 = { class: "d-flex gap-2" }
const _hoisted_9 = {
  key: 0,
  class: "badge badge-warning"
}
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "row mb-3" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = { class: "col-md-3 mt-3" }
const _hoisted_17 = {
  key: 0,
  class: "col-md-12 mt-2"
}
const _hoisted_18 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_19 = {
  key: 1,
  class: "text-center py-5"
}
const _hoisted_20 = {
  key: 2,
  class: "table-responsive"
}
const _hoisted_21 = { class: "table table-hover table-striped" }
const _hoisted_22 = { class: "d-flex flex-column" }
const _hoisted_23 = { class: "fw-bold" }
const _hoisted_24 = { class: "text-muted" }
const _hoisted_25 = { class: "d-flex flex-column" }
const _hoisted_26 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 3,
  class: "d-flex justify-content-between align-items-center mt-3"
}
const _hoisted_31 = { class: "pagination mb-0" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 0,
  class: "modal fade show",
  style: {"display":"block","background":"rgba(0,0,0,0.5)"},
  tabindex: "-1"
}
const _hoisted_34 = { class: "modal-dialog" }
const _hoisted_35 = { class: "modal-content" }
const _hoisted_36 = { class: "modal-header" }
const _hoisted_37 = { class: "modal-body" }
const _hoisted_38 = { class: "mb-3" }
const _hoisted_39 = { class: "form-label" }
const _hoisted_40 = { class: "mb-3" }
const _hoisted_41 = { class: "modal-footer" }
const _hoisted_42 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[19] || (_cache[19] = _createElementVNode("h5", null, "Bank Update Requests", -1)),
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.pendingCount > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.pendingCount) + " Pending ", 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-primary",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshData && _ctx.refreshData(...args)))
                  }, [...(_cache[18] || (_cache[18] = [
                    _createElementVNode("i", { class: "fa fa-refresh" }, null, -1),
                    _createTextVNode(" Refresh ", -1)
                  ]))])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", null, "Status Filter", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.status) = $event)),
                    onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args))),
                    class: "form-control"
                  }, [...(_cache[20] || (_cache[20] = [
                    _createElementVNode("option", { value: "" }, "All Status", -1),
                    _createElementVNode("option", { value: "pending" }, "Pending", -1),
                    _createElementVNode("option", { value: "approved" }, "Approved", -1),
                    _createElementVNode("option", { value: "rejected" }, "Rejected", -1)
                  ]))], 544), [
                    [_vModelSelect, _ctx.filters.status]
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", null, "Employee Name", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.employeeName) = $event)),
                    onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onEmployeeNameChange && _ctx.onEmployeeNameChange(...args))),
                    class: "form-control",
                    placeholder: "Search by employee name..."
                  }, null, 544), [
                    [_vModelText, _ctx.filters.employeeName]
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", null, "Employee ID", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.employeeId) = $event)),
                    onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onEmployeeIdChange && _ctx.onEmployeeIdChange(...args))),
                    class: "form-control",
                    placeholder: "Enter employee ID..."
                  }, null, 544), [
                    [_vModelText, _ctx.filters.employeeId]
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[24] || (_cache[24] = _createElementVNode("label", null, "Site Name", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.siteName) = $event)),
                    onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onSiteNameChange && _ctx.onSiteNameChange(...args))),
                    class: "form-control",
                    placeholder: "Search by site name..."
                  }, null, 544), [
                    [_vModelText, _ctx.filters.siteName]
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[26] || (_cache[26] = _createElementVNode("label", null, "Items per page", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters.limit) = $event)),
                    onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args))),
                    class: "form-control"
                  }, [...(_cache[25] || (_cache[25] = [
                    _createElementVNode("option", { value: 10 }, "10", -1),
                    _createElementVNode("option", { value: 20 }, "20", -1),
                    _createElementVNode("option", { value: 50 }, "50", -1),
                    _createElementVNode("option", { value: 100 }, "100", -1)
                  ]))], 544), [
                    [_vModelSelect, _ctx.filters.limit]
                  ])
                ]),
                (_ctx.hasActiveFilters)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-outline-secondary",
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)))
                      }, [...(_cache[27] || (_cache[27] = [
                        _createElementVNode("i", { class: "fa fa-times" }, null, -1),
                        _createTextVNode(" Clear All Filters ", -1)
                      ]))])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[28] || (_cache[28] = [
                    _createElementVNode("div", {
                      class: "spinner-border text-primary",
                      role: "status"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                    ], -1),
                    _createElementVNode("p", { class: "mt-2" }, "Loading bank update requests...", -1)
                  ]))]))
                : (!_ctx.requests || _ctx.requests.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[29] || (_cache[29] = [
                      _createElementVNode("i", { class: "fa fa-inbox fa-3x text-muted mb-3" }, null, -1),
                      _createElementVNode("p", { class: "text-muted" }, "No bank update requests found", -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("table", _hoisted_21, [
                        _cache[33] || (_cache[33] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Employee"),
                            _createElementVNode("th", null, "Employee Code"),
                            _createElementVNode("th", null, "Site Name"),
                            _createElementVNode("th", null, "Account Number"),
                            _createElementVNode("th", null, "Bank Name"),
                            _createElementVNode("th", null, "IFSC Code"),
                            _createElementVNode("th", null, "Requested Date"),
                            _createElementVNode("th", null, "Status"),
                            _createElementVNode("th", null, "Actions")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requests, (request) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: request._id
                            }, [
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("span", _hoisted_23, _toDisplayString(request.employeeId?.employeeName || 'N/A'), 1),
                                  _createElementVNode("small", _hoisted_24, _toDisplayString(request.employeeId?.email || ''), 1)
                                ])
                              ]),
                              _createElementVNode("td", null, _toDisplayString(request.employeeId?.employeeCode || 'N/A'), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_25, [
                                  _createElementVNode("span", null, _toDisplayString(request.employeeId?.siteId?.siteName || 'N/A'), 1)
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("code", null, _toDisplayString(request.accountNumber), 1)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(request.bankName), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("code", null, _toDisplayString(request.ifscCode), 1)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("small", null, _toDisplayString(_ctx.formatDate(request.requestedAt)), 1)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(_ctx.getStatusBadge(request.status).class)
                                }, _toDisplayString(_ctx.getStatusBadge(request.status).label), 3)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-info",
                                    onClick: ($event: any) => (_ctx.viewDetails(request._id)),
                                    title: "View Details"
                                  }, [...(_cache[30] || (_cache[30] = [
                                    _createElementVNode("i", { class: "fa fa-eye" }, null, -1)
                                  ]))], 8, _hoisted_27),
                                  (request.status === 'pending')
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "btn btn-sm btn-success",
                                        onClick: ($event: any) => (_ctx.approveRequest(request)),
                                        title: "Approve"
                                      }, [...(_cache[31] || (_cache[31] = [
                                        _createElementVNode("i", { class: "fa fa-check" }, null, -1)
                                      ]))], 8, _hoisted_28))
                                    : _createCommentVNode("", true),
                                  (request.status === 'pending')
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: "btn btn-sm btn-danger",
                                        onClick: ($event: any) => (_ctx.showRejectModal(request)),
                                        title: "Reject"
                                      }, [...(_cache[32] || (_cache[32] = [
                                        _createElementVNode("i", { class: "fa fa-times" }, null, -1)
                                      ]))], 8, _hoisted_29))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])),
              (_ctx.pagination && _ctx.pagination.totalPages > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("div", null, " Showing " + _toDisplayString(((_ctx.pagination.page - 1) * _ctx.pagination.limit) + 1) + " to " + _toDisplayString(Math.min(_ctx.pagination.page * _ctx.pagination.limit, _ctx.pagination.total)) + " of " + _toDisplayString(_ctx.pagination.total) + " entries ", 1),
                    _createElementVNode("nav", null, [
                      _createElementVNode("ul", _hoisted_31, [
                        _createElementVNode("li", {
                          class: _normalizeClass(["page-item", { disabled: _ctx.pagination.page === 1 }])
                        }, [
                          _createElementVNode("a", {
                            class: "page-link",
                            onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.pagination.page - 1)), ["prevent"])),
                            href: "#"
                          }, " Previous ")
                        ], 2),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visiblePages, (page) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: page,
                            class: _normalizeClass(["page-item", { active: page === _ctx.pagination.page }])
                          }, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _withModifiers(($event: any) => (_ctx.changePage(page)), ["prevent"]),
                              href: "#"
                            }, _toDisplayString(page), 9, _hoisted_32)
                          ], 2))
                        }), 128)),
                        _createElementVNode("li", {
                          class: _normalizeClass(["page-item", { disabled: _ctx.pagination.page === _ctx.pagination.totalPages }])
                        }, [
                          _createElementVNode("a", {
                            class: "page-link",
                            onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.pagination.page + 1)), ["prevent"])),
                            href: "#"
                          }, " Next ")
                        ], 2)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.showRejectDialog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _cache[34] || (_cache[34] = _createElementVNode("h5", { class: "modal-title" }, "Reject Bank Update Request", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.closeRejectModal && _ctx.closeRejectModal(...args)))
                })
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("label", _hoisted_39, [
                    _cache[35] || (_cache[35] = _createTextVNode("Employee: ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.selectedRequest?.employeeId?.employeeName), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _cache[36] || (_cache[36] = _createElementVNode("label", { class: "form-label" }, [
                    _createTextVNode("Rejection Reason "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.rejectionReason) = $event)),
                    class: "form-control",
                    rows: "4",
                    placeholder: "Enter the reason for rejection...",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.rejectionReason]
                  ]),
                  _cache[37] || (_cache[37] = _createElementVNode("small", { class: "text-muted" }, "Please provide a clear reason for the employee", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.closeRejectModal && _ctx.closeRejectModal(...args)))
                }, "Cancel"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.confirmReject && _ctx.confirmReject(...args))),
                  disabled: !_ctx.rejectionReason || _ctx.rejectionReason.trim() === ''
                }, [...(_cache[38] || (_cache[38] = [
                  _createElementVNode("i", { class: "fa fa-times" }, null, -1),
                  _createTextVNode(" Reject Request ", -1)
                ]))], 8, _hoisted_42)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}